// ORTOSAN CRO (16/10/2026) — butoanele „+ Adaugă" din blocul cart-gap-fill.
// Delegare pe document: drawer-ul își înlocuiește HTML-ul la fiecare refresh, deci nu legăm pe noduri.
(function () {
  if (window.__ortosanGapFill) return;
  window.__ortosanGapFill = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gapfill-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-loading');

    var box = btn.closest('[data-gapfill]');
    var context = box ? box.dataset.context : 'drawer';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.gapfillAdd), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        if (context === 'page') {
          window.location.reload();
          return;
        }
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        var label = btn.querySelector('span');
        if (label) label.textContent = 'Încearcă din nou';
      });
  });
})();
